<template>
  <v-dialog v-model="dialog" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" :block="$vuetify.breakpoint.xs" v-on="on">
        <v-icon small left>mdi-plus</v-icon>
        Add a user
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Add a user</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert type="error" v-if="errorMessage">
          <span v-html="errorMessage"></span>
        </v-alert>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Firstname"
                v-model="item.firstname"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Lastname"
                v-model="item.lastname"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Email"
                v-model="item.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Password"
                v-model="item.password"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="resetDialog">Reset</v-btn>
        <v-btn color="primary" text :loading="loading" @click="createItem">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    loading: false,
    item: {
      email: '',
      firstname: '',
      lastname: '',
      password: ''
    },
    errorMessage: '',
    showPassword: false
  }),
  methods: {
    createItem () {
      this.loading = true
      this.errorMessage = ''
      this.$http.post(this.$directory + '/users', this.item)
        .then(() => {
          this.dialog = false
          this.resetDialog()
          this.$emit('refresh')
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetDialog () {
      this.item = {
        email: '',
        firstname: '',
        lastname: '',
        password: ''
      }
      this.loading = false
    }
  }
}
</script>
